// Lib
import React from 'react';

// Hooks
import useClickOutside from 'hooks/useClickOutside';

interface ClickOutsideProps {
  children: JSX.Element;
  onClickOutside: VoidFunction;
}

const ClickOutside: React.FC<ClickOutsideProps> = ({ children, onClickOutside }): JSX.Element => {
  const { node } = useClickOutside(onClickOutside);

  return <span ref={node}>{children}</span>;
};

export default ClickOutside;
